import html from '../../../../assets/html.png';
import css from '../../../../assets/css.png';
import javascript from '../../../../assets/js.png';
import ruby from '../../../../assets/ruby.png';
import postgresql from '../../../../assets/postgres.png';
import nodejs from '../../../../assets/nodejs.png';
import react from '../../../../assets/react.png';
import rails from '../../../../assets/rails.png';
import postcss from '../../../../assets/postcss.png';
import bootstrap from '../../../../assets/bootstrap.png';
import redux from '../../../../assets/redux.png';
import express from '../../../../assets/express.png';
import mongodb from '../../../../assets/mongodb.png';
import github from '../../../../assets/github.png';
import git from '../../../../assets/git.png';
import postman from '../../../../assets/postman.png';
import illustrator from '../../../../assets/illustrator.png';
import photoshop from '../../../../assets/photoshop.png';
import jest from '../../../../assets/jest.png';
import webpack from '../../../../assets/webpack.png';

const languageItem = [
  {
    id: 1,
    name: 'Html',
    icon: html,
  },
  {
    id: 2,
    name: 'Css',
    icon: css,
  },
  {
    id: 3,
    name: 'Javascript',
    icon: javascript,
  },
  {
    id: 4,
    name: 'Ruby',
    icon: ruby,
  },
  {
    id: 5,
    name: 'Postgresql',
    icon: postgresql,
  },
  {
    id: 6,
    name: 'Nodejs',
    icon: nodejs,
  },
];

const frameworks = [
  {
    id: 1,
    name: 'React js',
    icon: react,
  },
  {
    id: 2,
    name: 'Rails',
    icon: rails,
  },
  {
    id: 3,
    name: 'PostCSS',
    icon: postcss,
  },
  {
    id: 4,
    name: 'Bootstrap',
    icon: bootstrap,
  },
  {
    id: 5,
    name: 'Express js',
    icon: express,
  },
  {
    id: 6,
    name: 'MongoDB',
    icon: mongodb,
  },
  {
    id: 7,
    name: 'Redux',
    icon: redux,
  },
];

const tools = [
  {
    id: 1,
    name: 'Github',
    icon: github,
  },
  {
    id: 2,
    name: 'Git',
    icon: git,
  },
  {
    id: 3,
    name: 'Postman',
    icon: postman,
  },
  {
    id: 4,
    name: 'Illustrator',
    icon: illustrator,
  },
  {
    id: 5,
    name: 'Photoshop',
    icon: photoshop,
  },
  {
    id: 6,
    name: 'Jest',
    icon: jest,
  },
  {
    id: 7,
    name: 'Webpack',
    icon: webpack,
  },
];

const proffessionalSkills = [
  {
    id: 1,
    name: 'Effective Communication',
  },
  {
    id: 2,
    name: 'Remote Pair-Programming',
  },
  {
    id: 3,
    name: 'Adaptability',
  },
  {
    id: 4,
    name: 'Critical thinking',
  },
  {
    id: 5,
    name: 'Leadership',
  },
  {
    id: 6,
    name: 'Time Management',
  },
  {
    id: 7,
    name: 'Scrum Habits',
  },
  {
    id: 8,
    name: 'Agile Methodologies',
  },
  {
    id: 9,
    name: 'Mentoring',
  },
];

export { frameworks, tools, proffessionalSkills };
export default languageItem;
